import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs, bounds } from "../utils/index"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"
import Sticky from "../components/Sticky"
import store from "../store"
import { ScrollTrigger } from "../libraries/gsap/index"

export default class SupportCategories extends Component {
  constructor(obj) {
    super(obj)

    // this.splitText = qsa("[data-split]", this.el)
    // this.textSplitter = new TextSplitScrollTrigger({
    //   el: this.el,
    //   splitText: this.splitText,
    //   animate: this.animate.bind(this),
    // })

    this.animate()
    // gsap.set(this.el, { autoAlpha: 0 })
  }

  animate() {
    const supportItems = qsa(".support-item", this.el)

    gsap.from(supportItems, {
      y: "100",
      autoAlpha: 0,
      duration: 1.2,
      stagger: 0.05,
      scrollTrigger: {
        trigger: supportItems,
        start: "top bottom",
      },
    })
  }
}
